import Tdg_UserModelBase from '../_generated/modelBases/tdg-user-model-base';

export default class Tdg_UserModel extends Tdg_UserModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
